import IState from "../state"

export const getSorting = (state: IState) => state.hrLeaveEntitlementsTable.data
// export const getDefaultSorting = (state: IState) => state.hrLeaveEntitlementsTable.defaultSorting
